import { Link } from "react-router-dom";
import { Check, ListChecks, Rocket, ShieldCheck, LayoutDashboard } from "lucide-react";
import { Button } from "@/components/ui/button";

const STEPS = [
  { icon: ListChecks, title: "Register your institution", desc: "Create your account and complete your institution profile in minutes." },
  { icon: LayoutDashboard, title: "Add your online courses", desc: "List programmes with details, fees, eligibility and specialisations." },
  { icon: Rocket, title: "Choose a listing plan", desc: "Start free, or upgrade to Standard or Premium for more visibility." },
  { icon: ShieldCheck, title: "Go live after approval", desc: "Once approved, students discover your courses and visit your website." },
];

export default function ForUniversities() {
  return (
    <div>
      <section className="bg-blue-800 py-16 text-center text-white">
        <div className="mx-auto max-w-3xl px-4">
          <h1 className="font-heading text-3xl font-bold tracking-tight md:text-4xl">List Your Online Programmes</h1>
          <p className="mx-auto mt-4 max-w-2xl text-blue-100">
            Reach students discovering online courses worldwide. Online Education Directory is a course discovery
            platform — we link students directly to your official website. No lead selling, no middlemen.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Button asChild size="lg" className="bg-white text-blue-800 hover:bg-slate-100" data-testid="for-uni-register-btn">
              <Link to="/register">Register Your Institution</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-white bg-transparent text-white hover:bg-white/10">
              <Link to="/pricing">See Listing Plans</Link>
            </Button>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-16 md:px-6">
        <h2 className="text-center font-heading text-2xl font-bold tracking-tight text-slate-900">How it works</h2>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <div key={s.title} className="rounded-xl border border-slate-200 bg-white p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-blue-50 text-blue-800"><s.icon className="h-5 w-5" /></span>
              <p className="mt-4 text-xs font-semibold text-blue-800">STEP {i + 1}</p>
              <h3 className="mt-1 font-heading font-semibold text-slate-900">{s.title}</h3>
              <p className="mt-1 text-sm text-slate-500">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-slate-50 py-16">
        <div className="mx-auto max-w-4xl px-4 md:px-6">
          <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center">
            <h2 className="font-heading text-2xl font-bold text-slate-900">A directory built on trust</h2>
            <div className="mt-6 grid gap-4 text-left sm:grid-cols-2">
              {["Both free and paid institutions appear in search",
                "Direct links to your official university website",
                "No student lead collection or reselling",
                "Full control of your listings from your dashboard"].map((t) => (
                <p key={t} className="flex items-start gap-2 text-slate-600"><Check className="mt-0.5 h-5 w-5 shrink-0 text-blue-800" />{t}</p>
              ))}
            </div>
            <Button asChild className="mt-8 bg-blue-800 hover:bg-blue-900"><Link to="/register">Get Started</Link></Button>
          </div>
        </div>
      </section>
    </div>
  );
}
